module.exports = __webpack_public_path__ + "media/images/ui__warning--dark-7feecc0cc894cb4bdd41417654324fab.png";